define('lib/Podio.UI.SharedFiles',['require','translate','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.UI.Modal','lib/Podio.Event.UI'],function(require) {

  var t = require('translate');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var modal = require('lib/Podio.UI.Modal');
  var eventUI = require('lib/Podio.Event.UI');

  function onRemoveAttachmentClicked(elmTarget, e) {
    var url = routes.file_path(elmTarget.data('file-id'));

    modal.showConfirm(t('Delete file #file'), t("Are you sure you want to delete this file? #file"), null, {yes: t('Yes, delete file #file'), no: t('Cancel') }, function(){

      transport.deleteJSON(url, {}, function(responseData) {
        var elmParent = elmTarget.parents('.uploaded-file-container:first, .uploaded-file:first');
        elmParent.fadeOut('fast');
      });

    });
  }

  eventUI.bind('click', '.uploaded-file-container a.remove-attachment, .uploaded-file a.remove-attachment', onRemoveAttachmentClicked);

});

